import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { removeCookie } from '@/shared/lib/utils/removeCookie';
import { logoutQuery } from '../api/logoutQuery';

type Props = {
    onError?: () => void;
    onSuccess?: () => void;
};

export const useLogout = ({ onSuccess, onError }: Props = {}) => {
    const { setErrorModalProps } = useModalStore();

    return useMutation({
        mutationFn: logoutQuery,
        onSuccess: () => {
            removeCookie('userId');
            onSuccess?.();
        },
        onError: (error: ResponseError) => {
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            setErrorModalProps({ isOpened: true, title: errorMessage });
            onError?.();
        },
        retry: false,
    });
};
